module.exports = __webpack_public_path__ + "static/media/zahid_group.a70cb461.svg";